import React from "react";
import { ValidationError } from '@formspree/react';

function Input({state, field, options, textarea = false}) {

    const HtmlInput = textarea ? 'textarea' : 'input';

    options = Object.assign({type: 'text'}, options);
    if(options.required) {
        options.placeholder = `${options.placeholder} *`;
    }

    return <>
        <label className="block">
            <HtmlInput
                className="mt-2 block w-full px-0.5 border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
                name={field}
                {...options}
            />
        </label>
        <ValidationError
            field={field}
            errors={state.errors}
        />
    </>;
}

export default Input;
